export class LaudosCDModel {
  id_laudo_cd: number;
  numero: number;
  id_cliente: string = null;
  id_importador: string = null;
  id_exportador: string = null;
  id_terminal: string = null;
  id_armador: string = null;
  id_unidade: string = null;
  id_pais_origem: string = null;
  id_transportadora: string = null;
  id_tipo_unidade: string = null;
  id_tipo_transporte: string = null;
  id_produto: string = null;
  id_variedade: string = null;
  id_embalagem: string = null;
  id_categoria: string = null;
  referencia: string;
  nf_importacao: string;
  identificacao_transporte: string;
  lacre_transporte: string;
  lote: string;
  quantidade: string;
  vol_analisados: string;
  shelf_life: string;
  shelf_life_label: string = null;
  marca: string;
  id_coloracao: string = null;
  temperaturas_polpa: any = [];
  temperatura_polpa_status: boolean = true;
  pressao_polpa_min: string;
  pressao_polpa_max: string;
  pressao_polpa_med: string;
  brix_min: string;
  brix_max: string;
  brix_med: string;
  data_descarga: string;
  data_inspecao: string;
  data_fabricacao: any = [];
  data_validade: any = [];
  estivagem: boolean = true;
  carga_avancada_porta: boolean = false;
  carga_avancada_teto: boolean = false;
  odor: boolean = true;
  rotulagem: boolean = true;
  pressao_poupa_status: boolean = true;
  temperatura_polpa_exibir: boolean = true;
  pressao_polpa_exibir: boolean = true;
  estivagem_exibir: boolean = true;
  paletizacao_exibir: boolean = true;
  brix_exibir: boolean = true;
  brix_status: boolean = true;
  paletizacao: boolean = true;
  avarias_carreta: boolean = false;
  prioridade_vendas: boolean = false;
  peso_liquido_vol: boolean = true;
  embalagem_danificada: boolean = false;
  sem_rotulo: boolean = false;
  sem_calibre: boolean = false;
  sem_pesagem: boolean = false;
  rotulo_divergente: boolean = false;
  calibre_min: boolean = true;
  calibre_max: boolean = true;
  calibre_med: boolean = true;
  stakeholders = [];
  responsaveis_tecnicos = [];
  observacoes = [];
  odr_valores: any = [];
  pesagem: any = null;
  pesagem_tara: string = null;
  pesagem_diferenca_final: string = null;
  pressao_polpa: any = [];
  brix: any = [];
  termografos: any = [];
  has_foto_termografo: boolean = false;
  id_status: number = 1;
  status: any;
  faturado: number;
  valor: any;
  exibir_odr: boolean = false;
  exibir_informacoes_bl: boolean = false;
  setpoint: string;
  setpoint_off: boolean = false;
  airtemperature: string;
  airtemperature_off: boolean = false;
  ventilacao_container: string;
  ventilacao_container_unidade: string = null;
  sem_ventilacao_container: boolean = false;
  ventilacao_container_automatico: boolean = false;
  ventilacao_bl: string;
  ventilacao_bl_unidade: string = null;
  ventilacao_bl_fechado: boolean = false;
  temperatura_bl: string;
  tamanho_calibre: string = null;
  bl_crt_mic: string;
  lpco: string;
  id_local_embarque: string = null;
  id_local_chegada: string = null;
  data_embarque: string;
  data_chegada: string;
  bl_to_port: number;
  crt_to_house: number;
  invoice: string;
  indices_conclusao: any;
  comentarios_exibir: boolean = false;
  comentarios_pt: string;
  comentarios_en: string;
  comentarios_es: string;
  comentarios_cor: number = null;
}



// WEBPACK FOOTER //
// ./src/app/laudos-cd/laudos-cd.model.ts